import React from 'react';

import Link from 'libs/router/Link';

import { __t, applyTranslations } from 'utils/language';

import './access-header.scss';

applyTranslations(require('./access-header.i18n.json'));

const HeaderAccess = () => (
  <header className="access-header">
    <div className="access-header__logo-full">
      <Link to="/">
        <img
          data-src="/static/images/logo-header-black.svg"
          className="lazyload"
          style={{ width: 280, height: 75 }}
          alt={__t('logo_alt')}
        />
      </Link>
    </div>
  </header>
);

export default HeaderAccess;
